import * as yup from 'yup'
import { email, emailRgx, emailvalidMessage } from './patterns/pattern'
import valid from 'card-validator'
const passwordRegx = /[!"#$%&()*+,-./:;<=>?€£@[\\\]^_{|}~]/
const passwordNotAllow = /^[^`'’]+$/
const NameRegx = /^(?!\s)(?:[A-Za-z]+(?: [A-Za-z]+)*)?$/
// const uniqueTasks = (tasks) => {
//   const taskSet = new Set()
//   for (const task of tasks) {
//     if (taskSet.has(task.task)) {
//       return false // Duplicate task found
//     }
//     taskSet.add(task.task)
//   }
//   return true // All tasks are unique
// }

export const registerFormschema = yup
  .object({
    first_name: yup
      .string()
      .required('First name is required.')
      .min(2, 'First name must be at least 2 characters long.')
      .max(50, 'First name must not be more than 50 characters.')
      .test('noNumbers', 'First name should not contain numbers.', (value) => !/\d/.test(value))
      .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
    last_name: yup
      .string()
      .required('Last name is required.')
      .min(2, 'Last name must be at least 2 characters long.')
      .max(50, 'Last name must not be more than 50 characters.')
      .test('noNumbers', 'Last name should not contain numbers.', (value) => !/\d/.test(value))
      .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.'),
    email: yup.string().required('Email is required.').matches(emailRgx, emailvalidMessage).max(64).trim(),
    contact_no: yup
      .string()
      .required('Phone number is required.')
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Phone number must be in the format (xxx) xxx-xxxx.')
      .test('not-all-zeros', 'Phone number cannot be all zeros.', (value) => value && !/^\(000\) 000-0000$/.test(value)),
    password: yup
      .string()
      .required('Password is required.')
      .matches(/^\S*$/, 'Password must not contain blank spaces.') // No spaces allowed
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter.')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter.')
      .matches(/\d/, 'Password must contain at least one number.')
      .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
      .matches(passwordRegx, 'Password must contain at least one special character.')
      .min(6, 'Password must be at least 6 characters long.')
      .max(10, 'Password should be maximum 10 characters long.')
      .trim(),
    confirmPassword: yup
      .string()
      .required('Confirm Password is required.')
      .oneOf([yup.ref('password'), null], 'Password must match.'),
    is_term_accepted: yup.boolean().oneOf([true], 'Please accept terms and conditions.').required('Please accept terms and conditions.')
    // personal_address: yup.string().required('Address is required').min(10, 'Address must be at least 10 characters')
  })
  .required()

export const loginFormScheme = yup.object({
  // email: yup.string().required('Email is required').matches(email, 'Enter a valid email address').trim(),
  email: yup.string().required('Email address is required.').matches(emailRgx, emailvalidMessage).max(64).trim(),
  password: yup
    .string()
    .required('Password is required.')
    .matches(/^\S*$/, 'Password must not contain blank spaces.') // No spaces allowed
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter.')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter.')
    .matches(/\d/, 'Password must contain at least one number.')
    .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'Password must contain at least one special character.')
    .min(6, 'Password must be at least 6 characters long.')
    .max(10, 'Password should be maximum 10 characters long.')
    .trim()
})

export const forgotPasswordSchema = yup.object({
  email: yup.string().required('Email is required.').matches(email, 'Invalid email.').trim()
})

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required('Password is required.')
    .matches(/^\S*$/, 'Password must not contain blank spaces.') // No spaces allowed
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter.')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter.')
    .matches(/\d/, 'Password must contain at least one number.')
    .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'Password must contain at least one special character.')
    .min(6, 'Password must be at least 6 characters long.')
    .max(10, 'Password should be maximum 10 characters long.')
    .trim(),
  confirmPassword: yup
    .string()
    .required('Password is mendatory')
    .oneOf([yup.ref('password')], 'Password does not match.')
})

export const propertySchema = yup.object().shape({
  property_name: yup
    .string()
    // .trim()
    .required('Property name is required.')
    .matches(
      /^(?=.*[A-Za-z])[A-Za-z0-9.@\\&*, \\/\\_'’’`-]+$/,
      "Property name can only contain letters, numbers, spaces, and the symbols /\\.@-_,`’'&* without leading or trailing spaces."
    )
    .min(2, 'Property name must be at least 2 characters long.')
    .max(50, 'Property name cannot be more than 50 characters.'),
  zipcode: yup
    .string()
    .trim()
    .required('Zipcode is required.')
    .matches(/^[0-9]+$/, 'Zipcode must be digits.')
    .typeError('Only digits are allowed.')
    .min(2, 'Zipcode should be at least 2 characters.')
    .max(7, 'Zipcode should be maximum 7 characters.'),
  address: yup.string().trim().required('Address is required.'),
  state: yup
    .string()
    .trim()
    .required('State is required.')
    .matches(/^[A-Za-z\s]+$/, 'State can only contain letters.'),
  city: yup
    .string()
    .trim()
    .required('City is required.')
    .matches(/^[A-Za-z\s]+$/, 'City can only contain letters.'),
  number_of_rooms: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue ? (originalValue?.toString().trim() ? value : null) : null
    })
    .typeError('Number of rooms must be a valid number.')
    .required('Number of rooms is required.')
    .min(0, 'Number of rooms cannot be negative.')
    .max(1000000, 'Number of rooms is too large.')
    .test(
      'is-valid-decimal',
      'Number of rooms must have up to 2 decimal places.',
      (value) => value === undefined || value.toString().match(/^\d+(\.\d{1,2})?$/)
    ),
  number_of_bathroom: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue ? (originalValue?.toString().trim() ? value : null) : null
    })
    .typeError('Number of bathrooms must be a valid number.')
    .required('Number of bathrooms is required.')
    .min(0, 'Number of bathrooms cannot be negative.')
    .max(1000000, 'Number of bathrooms is too large.')
    .test(
      'is-valid-decimal',
      'Number of bathrooms must have up to 2 decimal places.',
      (value) => value === undefined || value.toString().match(/^\d+(\.\d{1,2})?$/)
    ),
  square_foot: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue ? (originalValue?.toString().trim() ? value : null) : null
    })
    .typeError('Square feet must be a valid number.')
    .required('Square feet is required.')
    .min(1, 'Square feet cannot be negative 0r 0.')
    .max(1000000, 'Square feet is too large.')
    .test(
      'is-valid-decimal',
      'Square feet count must be a whole number or have up to 2 decimal places.',
      (value) => value === undefined || /^[0-9]+(\.[1-9][0-9]?)?$/.test(value.toString())
    ),
  get_in: yup.string().trim().required('This field is required.'),
  get_in_instruction: yup
    .string()
    .required('Get-in instruction / door code is required.')
    .min(2, 'Get-in instruction / door code should be at least 2 characters')
    .max(255, 'Get-in instruction / door code must be at most 255 characters long'),
  laundry_code: yup.string().nullable().notRequired(),
  storage_area_code: yup.string().trim().nullable().notRequired(),

  // storage_area_code: yup.string().trim().optional(),

  // cleaning_on: yup.string().nullable().oneOf(['Cleaning on checkout', 'Cleaning on checkin'], 'Invalid selection'),

  propertyTasks: yup.array().of(
    yup.object().shape({
      task: yup
        .string()
        .trim()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .notRequired()
        .min(2, 'Task must be at least 2 characters long.')
        .max(255, 'Task must be at most 255 characters long.')
        .matches(
          /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.@\\&*, \\/\\_-]+(?<!\s)$/,
          'Task can only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'
        )
    })
  ),

  propertyConsumables: yup.array().of(
    yup.object().shape({
      task: yup
        .string()
        .trim()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .notRequired()
        .min(2, 'Item must be at least 2 characters long.')
        .max(255, 'Item must be at most 255 characters long.')
        .matches(
          /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.@\\&*, \\/\\_-]+(?<!\s)$/,
          'Item can only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'
        )
    })
  ),
  propertyICalLink: yup.array().of(
    yup.object().shape({
      ical_label: yup.string().test('label-required-if-link', 'ICAL label is required.', function (value) {
        const { ical_link } = this.parent
        return !ical_link || (ical_link && value)
      }),
      ical_link: yup
        .string()
        .test('link-required-if-label', 'ICAL link is required.', function (value) {
          const { ical_label } = this.parent
          return !ical_label || (ical_label && value)
        })
        .test('valid-url-if-present', 'ICAL link must be a valid URL.', function (value) {
          if (!value) return true // Don't validate if empty
          return yup.string().url().isValidSync(value)
        })
    })
  )
})

export const scheduleCleningSchema = yup.object().shape({
  booking_date_time: yup.string().required('Booking date and time is required.'),
  next_checkin_time: yup
    .string()
    .nullable()
    .test('is-future-date', 'Booking date and time must be in the future.', (value) => {
      if (!value) return true
      const bookingNextCkeckIn = new Date(value)
      const now = new Date()
      return bookingNextCkeckIn >= now
    })
    .test('checkInAfterBooking', 'Check-in date must be after booking date.', (value, context) => {
      if (!value) return true
      const bookingDateTime = context.parent.booking_date_time
      if (!value || !bookingDateTime) return false
      return new Date(value) > new Date(bookingDateTime)
    })
})

export const extendCleningSchema = yup.object().shape({
  next_checkout_time: yup.string().required('Booking date and time is required.'),
  next_checkin_time: yup.string().nullable()
})
// export const propertySchema = [
//   yup.object({
//     property_name: yup.string().required('Property Name is required'),
//     zipcode: yup
//       .string()
//       .required('Zipcode is required')
//       .matches(/^\d{6}$/, 'Zipcode must be exactly 6 digits'),
//     address: yup.string().required('Address is required'),
//     state: yup.string().required('State is required'),
//     city: yup.string().required('City is required'),
//     number_of_rooms: yup.number().required('Number of Rooms is required').min(1, 'Number of Rooms must be at least 1'),
//     number_of_bathroom: yup.number().required('Number of Bathrooms is required').min(1, 'Number of Bathrooms must be at least 1'),
//     square_foot: yup.number().required('Square Feet is required').min(1, 'Square Feet cannot be empty'),
//     other: yup.string().required('Other is required')
//   }),
//   yup.object({
//     get_in: yup.string().required('This field is required'),
//     get_in_instruction: yup.string().required('Instruction is required')
//   }),
//   yup.object().shape({
//     propertyICalLink: yup.array().of(
//       yup.object().shape({
//         ical_label: yup.string().required('iCal Label is required'),
//         ical_link: yup.string().url('Invalid URL').required('iCal Link is required')
//       })
//     ),
//     cleaning_on: yup.string().nullable().oneOf(['Cleaning on checkout', 'Cleaning on checkin'], 'Invalid selection')
//   }),
//   yup.object().shape({
//     propertyTasks: yup.array().of(
//       yup.object().shape({
//         task: yup.string().min(1, 'Task cannot be empty').required('New Task is required')
//       })
//     )
//   }),
//   yup.object().shape({
//     propertyConsumables: yup.array().of(
//       yup.object().shape({
//         task: yup.string().min(1, 'Item cannot be empty').required('New Item is required')
//       })
//     )
//   })
// ]

export const addiCalSchema = yup.object().shape({
  propertyICalLink: yup.array().of(
    yup.object().shape({
      ical_label: yup.string().required('iCal label is required.'),
      ical_link: yup.string().url('iCal link must be a valid URL.').required('iCal Link is required.')
    })
  ),
  cleaning_on: yup.string().required('Cleaning option is required.')
})

export const scheduleCleaningSchema = yup.object().shape({
  checkout_at: yup.date().required('Checkout time is required.').typeError('Invalid date format.'),
  checkin_at: yup.date().required('Check-in time is required.').typeError('Invalid date format.'),
  coupon_code: yup
    .string()
    .nullable()
    .matches(/^[A-Z0-9]{6,10}$/, 'Invalid coupon code format.') // Example validation for coupon code
})

export const editProfileSchema = yup.object().shape({
  first_name: yup
    .string()
    .required('First name is required.')
    .min(2, 'First name must be at least 2 characters long.')
    .max(50, 'First name must not be more than 50 characters.')
    .test('noNumbers', 'First name should not contain numbers.', (value) => !/\d/.test(value))
    .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
  last_name: yup
    .string()
    .required('Last name is required.')
    .min(2, 'Last name must be at least 2 characters long.')
    .max(50, 'Last name must not be more than 50 characters.')
    .test('noNumbers', 'Last name should not contain numbers.', (value) => !/\d/.test(value))
    .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.'),
  email: yup.string().email('Enter a valid email address.').required('Email is required.'),
  contact_no: yup
    .string()
    .required('Phone number is required.')
    .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Phone number must be in the format (xxx) xxx-xxxx.')
    .test('not-all-zeros', 'Phone number cannot be all zeros.', (value) => value && !/^\(000\) 000-0000$/.test(value))
})

export const changePasswordSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is required.'),
  newPassword: yup
    .string()
    .required('New password is required.')
    .matches(/^\S*$/, 'New password must not contain blank spaces.') // No spaces allowed
    .matches(/[A-Z]/, 'New password must contain at least one uppercase letter.')
    .matches(/[a-z]/, 'New password must contain at least one lowercase letter.')
    .matches(/\d/, 'New password must contain at least one number.')
    .matches(passwordNotAllow, "New password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'New password must contain at least one special character.')
    .min(6, 'New password must be at least 6 characters long.')
    .max(10, 'New password should be maximum 10 characters long.')
    .trim(),
  confirmNewPassword: yup
    .string()
    .required('Confirm password is required.')
    .oneOf([yup.ref('newPassword'), null], 'Password must match.')
})

export const creditCardSchema = yup.object().shape({
  card_holder: yup
    .string()
    .required('Cardholder name is required.')
    .max(25, 'Cardholder name must not be more than 25 letters.')
    .matches(/^(?!\s)[A-Za-z-]+( [A-Za-z-]+)*(?<!\s)$/, 'Cardholder name must only contain letters.'),
  card_number: yup
    .string()
    .required('Card numer is required.')
    .test('valid-card', 'Invalid card number.', (value) => {
      if (!value) return false
      const validation = valid.number(value)
      return validation.isValid
    }),

  expired_at: yup
    .string()
    .required('Expiry date is required.')
    .matches(/^(19|20)\d{2}-(0[1-9]|1[0-2])$/, 'Expiry date must be in the format YYYY-MM.')
    .test('valid-month', 'Expiry date must be a future date.', (value) => {
      if (!value) return true
      const [year, month] = value.split('-')
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth() + 1

      return parseInt(year) > currentYear || (parseInt(year) === currentYear && parseInt(month) > currentMonth)
    }),
  cvc: yup
    .string()
    .required('CVC is required.')
    .matches(/\d/, 'CVC must be digits.')
    .typeError('Only digits are allowed.')
    .when('card_size', (card_size, schema) => {
      if (!card_size) {
        return
      }
      return schema.min(card_size, `CVC should be at least ${card_size} digits.`).max(card_size, `CVC should be maximum ${card_size} digits.`)
    })
})
